import { toJS } from 'mobx'

import i18n from 'i18next'
import _ from 'lodash'
import moment from 'moment-timezone'
import {
  apptTypes,
  TIME_FOR_CONFIRMATION,
  TIME_FOR_ONSITE_REBOOK,
  TIME_FOR_VIRTUAL_REBOOK,
} from 'ziphy-web-shared/basic/entities/appointments'
import { formatAmount } from 'ziphy-web-shared/basic/helpers'
import { $windowSize } from 'ziphy-web-shared/basic/utils'

import { $appts } from '@store'

import { apptActions } from '@config/appts'
import { getAllStatuses } from '@config/apptsCore'
import mainConfig from '@config/main'

class hApptCore {
  formsNotFilled({ encounters }) {
    let result = {
      encounters: {},
      any: true,
    }
    _.forEach(encounters, (enc, encId) => {
      const documentTemplates = toJS($appts.documentTemplates)[encId]

      if (documentTemplates) {
        result.encounters[encId] = _.some(documentTemplates, (x) => !x.isAccepted)
      } else {
        result.encounters[encId] =
          !enc.telehealthConsentId || !enc.hipaaConsentId || !enc.patientIntakeId
      }
    })

    result.any = _.some(Object.values(result.encounters), (x) => x)
    return result
  }

  typeLabel({ service }) {
    return _.trim(service?.name)
  }

  isFree(amount) {
    return amount <= 0
  }

  amount({ appointment }) {
    if (this.isFree(appointment.amount)) {
      return i18n.t('appt.price.free')
    }

    return formatAmount(appointment.amount, appointment.currency)
  }

  isTimeInProgress({ appointment }) {
    const { appointedStart, appointedFinish } = appointment
    const start = moment.utc(appointedStart).subtract(0, 'hours')
    const end = moment.utc(appointedFinish)
    const now = moment.utc()

    return now.isSameOrAfter(start) && now.isSameOrBefore(end)
  }

  getMeetingId(fullAppt) {
    const { agent, provider, service } = fullAppt

    if (apptTypes.isStartAgent(service)) {
      return agent.meetingId
    } else {
      return provider.meetingId
    }
  }

  meetingUrl({ fullAppt, status = {}, type, source = 'auto' }) {
    let meetingId = this.getMeetingId(fullAppt)
    let url

    if (_.isUndefined(type)) {
      type = mainConfig.appType !== 'client' && status.isStartProvider ? 'start' : 'join'
    }

    const list = mainConfig.zoom[type] || {}

    if ((source === 'auto' && $windowSize.isMobile) || source === 'browser') {
      url = list.browser
    } else {
      url = list.app
    }

    return _.replace(url, '{{meetingId}}', meetingId)
  }

  getCurrentStatus(fullAppt) {
    const statuses = getAllStatuses(fullAppt)
    return _.find(statuses, (x) => x.current) || {}
  }

  extendFullAppt(fullAppt) {
    const status = this.getCurrentStatus(fullAppt)
    const actions = apptActions({ fullAppt, status }, true)

    return { fullAppt, status, actions }
  }

  isTimeToConfirm({ appointment }) {
    const { appointedStart } = appointment
    const start = moment.utc(appointedStart)
    const now = moment.utc()
    const dt = start.diff(now, 'minutes')

    return dt < TIME_FOR_CONFIRMATION
  }

  isCanRebook({ appointment, service }) {
    const { appointedStart } = appointment

    const start = moment.utc(appointedStart)
    const now = moment.utc()
    const dt = start.diff(now, 'minutes')

    const isVirtual = apptTypes.isVirtual(service)
    const availableTime = isVirtual ? TIME_FOR_VIRTUAL_REBOOK : TIME_FOR_ONSITE_REBOOK

    return dt > availableTime
  }

  feesAmount({ appointment, payment }) {
    const isCanceled = appointment.status === 'canceled'
    const isPaid = payment.status && payment.status !== 'refunded'

    if (!this.isFree(appointment.amount) && isCanceled && isPaid) {
      return formatAmount(appointment.amount, appointment.currency)
    }

    return false
  }
}

export default new hApptCore()
